import React from 'react';
import { useCombinedStore } from '../store';
import Modal from 'react-modal';
import MessageBox from './MessageBox';
import api from '../services/api.service';
import * as Styles from '../styles/Confirmation.Modal.styles';
import alfredoIcon from '../assets/alfredo-icon.svg';

const PrintOrderModal: React.FC<{
  isOpen: boolean;
  title: string;
  description: string;
  items: any;
  selectedSaleOption: any;
  confirmationAction: (value: string) => void;
  cancelationAction: () => void;
  onRequestClose: () => void;
}> = ({
  isOpen,
  title,
  description,
  items,
  selectedSaleOption,
  confirmationAction,
  cancelationAction,
  onRequestClose,
}) => {
    const {
      subsidiaryDataZustand,
      orderDataZustand,
      setMessageZustand,
    } = useCombinedStore((state) => ({
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
    }));

    const modalWrapperRef = React.useRef<HTMLDivElement>(null);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Enter') {
        confirmationAction('');
      }
    };

    React.useEffect(() => {
      if (isOpen) {
        setTimeout(() => {
          modalWrapperRef.current?.focus();
        }, 50);
      }
    }, [isOpen]);

    const handleSelectChange = (value: string) => {
      api.post(
        `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption?.itemInfoValue.saleOptionPrinterAddress}/${value}`
      );
      api.patch(`/order/${orderDataZustand.orderUuid}`, {
        orderStatus: 5,
      });
      setMessageZustand(`Conta impressa com sucesso!`, `success`);
      onRequestClose();
    };

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={Styles.customStyles}
        contentLabel="Main Modal"
        ariaHideApp={false}
      >
        <MessageBox />
        <Styles.ModalWrapper
          tabIndex={-1}
          ref={modalWrapperRef}
          onKeyDown={handleKeyDown}
        >
          <Styles.ModalContent>
            <Styles.ModalHeader
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
              <Styles.ModalTitle>{title}</Styles.ModalTitle>
              <Styles.ModalDescription>{description}</Styles.ModalDescription>
            </Styles.ModalHeader>
            <Styles.ModalBody
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .backgroundColor
              }
            >
              <Styles.DropdownInput
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                <select onChange={(e) => handleSelectChange(e.target.value)}>
                  <option value="">Selecione</option>
                  {items?.map((peopleNumber: any, index: number) => (
                    <option key={index} value={peopleNumber.value}>
                      {peopleNumber.label}
                    </option>
                  ))}
                </select>
                <label>Imprimir por lugar</label>
              </Styles.DropdownInput>
            </Styles.ModalBody>
            <Styles.ModalFooter
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Button
                onClick={() => {
                  cancelationAction();
                  onRequestClose();
                }}
              >
                Cancelar
              </Styles.Button>
              <div style={{ display: 'flex' }}>
                <Styles.Button onClick={() => confirmationAction('')}>
                  Imprimir Conta Inteira
                </Styles.Button>
              </div>
            </Styles.ModalFooter>
          </Styles.ModalContent>
        </Styles.ModalWrapper>
      </Modal>
    );
  };

export default PrintOrderModal;